export const SEARCH_DELAY = 500;

export const CONVERSATION_TYPE_OPTIONS = [
  { value: 'TextConversation', label: 'SMS' },
  { value: 'AnalyticsCall', label: 'AI Call' },
  { value: 'AgentCall', label: 'Agent Call' },
];

export const SCORE_OPTIONS = [
  { value: 'low', label: 'Low Rate' },
  { value: 'medium', label: 'Medium Rate' },
  { value: 'high', label: 'High Rate' },
];

export const SCORE_TYPE_OPTIONS = [
  { value: 'numeric', label: 'Numeric' },
  { value: 'text', label: 'Text' },
];
